import axios from "axios";

import { AXIOS_DEFAULT_CONFIG, routes } from "../../constants";

const getUpgradeOrder = async (token) => {
    const response = await axios.get(routes.getTicketUpgradeOrder(token), AXIOS_DEFAULT_CONFIG);
    return response;
};
export default getUpgradeOrder;
